import type { ComponentType } from 'react';
import type { Serializable } from '@wix/dashboard';

type HostExtensionBase = { componentId: string; title: string };

type HostExtensionWidget = HostExtensionBase & {
  Extension: ComponentType;
  menuItem?: never;
  isPermitted?: never;
};

type HostExtensionMenuItem = HostExtensionBase & {
  menuItem: {
    IconComponent?: ComponentType;
    IconSmallComponent?: ComponentType;
    structuredAction: (props?: Record<string, Serializable>) => void;
    subtitle?: string;
  };
  isPermitted: boolean;
  Extension?: never;
};

export type PermissionsStrategy = 'filter' | 'no-permitted-widget' | 'ignore';

export type UseContainerWidgets = (
  containerId: string,
  options?: {
    skeletonClassName?: string;
    permissionsStrategy: PermissionsStrategy;
  },
) => HostExtensionWidget[];

export type UseContainerMenuItems = (
  containerId: string,
  options?: {
    permissionsStrategy: PermissionsStrategy;
  },
) => HostExtensionMenuItem[];
